export function addIdBeneficio(idBeneficio) {
  return {
    type: 'ADD_ID_BENEFICIO',
    idBeneficio,
  };
}
